// Generated by purs version 0.13.5
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Effect = require("../Effect/index.js");
var Effect_Uncurried = require("../Effect.Uncurried/index.js");
var Web_DOM_Document = require("../Web.DOM.Document/index.js");
var Web_DOM_Element = require("../Web.DOM.Element/index.js");
var Web_DOM_Node = require("../Web.DOM.Node/index.js");
var Web_DOM_NonElementParentNode = require("../Web.DOM.NonElementParentNode/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_HTMLDocument = require("../Web.HTML.HTMLDocument/index.js");
var Web_HTML_HTMLElement = require("../Web.HTML.HTMLElement/index.js");
var Web_HTML_HTMLInputElement = require("../Web.HTML.HTMLInputElement/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var execCommand = Effect_Uncurried.runEffectFn2($foreign.execCommandImpl);
var copyToClipboard = function (text) {
    return function __do() {
        var v = Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window)();
        var v1 = (function __do() {
            var v1 = Web_DOM_NonElementParentNode.getElementById("clipboard-transfer-element")(Web_HTML_HTMLDocument.toNonElementParentNode(v))();
            return Data_Maybe.maybe(function __do() {
                var v2 = Web_DOM_Document.createElement("input")(Web_HTML_HTMLDocument.toDocument(v))();
                Web_DOM_Element.setId("clipboard-transfer-element")(v2)();
                Web_DOM_Element.setAttribute("style")("position: absolute; left: -1000px")(v2)();
                var v3 = Data_Functor.map(Effect.functorEffect)(Data_Maybe.fromJust())(Web_HTML_HTMLDocument.body(v))();
                var v4 = Web_DOM_Node.appendChild(Web_DOM_Element.toNode(v2))(Web_HTML_HTMLElement.toNode(v3))();
                return v2;
            })(Control_Applicative.pure(Effect.applicativeEffect))(v1)();
        })();
        var htmlInputElement = Data_Maybe.fromJust()(Web_HTML_HTMLInputElement.fromElement(v1));
        Web_HTML_HTMLInputElement.setValue(text)(htmlInputElement)();
        Web_HTML_HTMLInputElement.select(htmlInputElement)();
        return execCommand("copy")("")();
    };
};
module.exports = {
    execCommand: execCommand,
    copyToClipboard: copyToClipboard,
    execCommandImpl: $foreign.execCommandImpl
};
